import step1 from './images/hostaway_step1.jpg';
import step2 from './images/hostaway_step2.jpg';
import step3 from './images/hostaway_step3.jpg';
import step4 from './images/hostaway_step4.jpg';
import step5 from './images/hostaway_step5.jpg';
import step6 from './images/hostaway_step6.jpg';
import step7 from './images/hostaway_step7.jpg';
import step8 from './images/hostaway_step8.jpg';
import step9 from './images/hostaway_step9.jpg';
import step10 from './images/hostaway_step10.jpg';
import lodgify_step1 from './images/lodgify_step1.jpg';
import lodgify_step2 from './images/lodgify_step2.jpg';
import lodgify_step3 from './images/lodgify_step3.png';
import lodgify_step4 from './images/lodgify_step4.jpg';
import lodgify_step5 from './images/lodgify_step5.jpg';
import lodgify_step6 from './images/lodgify_step6.jpg';
import lodgify_step7 from './images/lodgify_step7.jpg';
import lodgify_step8 from './images/lodgify_step8.jpg';
import lodgify_step9 from './images/lodgify_step9.jpg';
import lodgify_step10 from './images/lodgify_step10.jpg';
import lodgify_step11 from './images/lodgify_step11.jpg';
import lodgify_step12 from './images/lodgify_step12.jpg';
import lodgify_step13 from './images/lodgify_step13.jpg';
import ownerrez_step1 from './images/ownerrez_step1.jpg';
import ownerrez_step2 from './images/ownerrez_step2.jpg';
import ownerrez_step3 from './images/ownerrez_step3.jpg';
import ownerrez_step4 from './images/ownerrez_step4.jpg';
import ownerrez_step5 from './images/ownerrez_step5.jpg';
import ownerrez_step6 from './images/ownerrez_step6.jpg';
import ownerrez_step7 from './images/ownerrez_step7.jpg';
import guesty_lite_step1 from './images/guesty_lite_step1.png';
import guesty_lite_step2 from './images/guesty_lite_step2.png';
import guesty_lite_step3 from './images/guesty_lite_step3.png';
import guesty_lite_step4 from './images/guesty_lite_step4.png';
import guesty_lite_step5 from './images/guesty_lite_step5.png';
import guesty_lite_step6 from './images/guesty_lite_step6.png';
import guesty_lite_step7 from './images/guesty_lite_step7.png';
import hostfully_step1 from './images/hostfully_step1.png';
import hostfully_step2 from './images/hostfully_step2.png';
import hostfully_step3 from './images/hostfully_step3.png';
import hostfully_step4 from './images/hostfully_step4.png';
import hostfully_step5 from './images/hostfully_step5.png';
import hostfully_step6 from './images/hostfully_step6.png';
import hostfully_step7 from './images/hostfully_step7.png';
import hostfully_step8 from './images/hostfully_step8.png';
import hostfully_step9 from './images/hostfully_step9.png';
import hostfully_step10 from './images/hostfully_step10.png';
import hostfully_step11 from './images/hostfully_step11.png';
import hostfully_step12 from './images/hostfully_step12.png';
import hostfully_step13 from './images/hostfully_step13.png';
import hostfully_step14 from './images/hostfully_step14.png';
import hostfully_step15 from './images/hostfully_step15.png';
import hostfully_step16 from './images/hostfully_step16.png';
import hostfully_step17 from './images/hostfully_step17.png';
import hostfully_step18 from './images/hostfully_step18.png';
import hostfully_step19 from './images/hostfully_step19.png';
import guesty_step1 from './images/guesty_step1.png';
import guesty_step2 from './images/guesty_step2.png';
import guesty_step3 from './images/guesty_step3.png';
import guesty_step4 from './images/guesty_step4.png';
import guesty_step5 from './images/guesty_step5.png';
import guesty_step6 from './images/guesty_step6.png';
import guesty_step7 from './images/guesty_step7.png';
import guesty_step8 from './images/guesty_step8.png';
import guesty_step9 from './images/guesty_step9.png';
import guesty_step10 from './images/guesty_step10.png';
import guesty_step11 from './images/guesty_step11.png';

const hostawayStepByStepInstructions = {
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9,
  step10,
};

export { hostawayStepByStepInstructions };

const lodgifyStepByStepInstructions = {
  lodgify_step1,
  lodgify_step2,
  lodgify_step3,
  lodgify_step4,
  lodgify_step5,
  lodgify_step6,
  lodgify_step7,
  lodgify_step8,
  lodgify_step9,
  lodgify_step10,
  lodgify_step11,
  lodgify_step12,
  lodgify_step13,
};

export { lodgifyStepByStepInstructions };

const ownerrezStepByStepInstructions = {
  ownerrez_step1,
  ownerrez_step2,
  ownerrez_step3,
  ownerrez_step4,
  ownerrez_step5,
  ownerrez_step6,
  ownerrez_step7,
};

export { ownerrezStepByStepInstructions };

const guestyLiteStepByStepInstructions = {
  guesty_lite_step1,
  guesty_lite_step2,
  guesty_lite_step3,
  guesty_lite_step4,
  guesty_lite_step5,
  guesty_lite_step6,
  guesty_lite_step7,
};

export { guestyLiteStepByStepInstructions };

const hostfullyStepByStepInstructions = {
  hostfully_step1,
  hostfully_step2,
  hostfully_step3,
  hostfully_step4,
  hostfully_step5,
  hostfully_step6,
  hostfully_step7,
  hostfully_step8,
  hostfully_step9,
  hostfully_step10,
  hostfully_step11,
  hostfully_step12,
  hostfully_step13,
  hostfully_step14,
  hostfully_step15,
  hostfully_step16,
  hostfully_step17,
  hostfully_step18,
  hostfully_step19,
};

export { hostfullyStepByStepInstructions };

const guestyStepByStepInstructions = {
  guesty_step1,
  guesty_step2,
  guesty_step3,
  guesty_step4,
  guesty_step5,
  guesty_step6,
  guesty_step7,
  guesty_step8,
  guesty_step9,
  guesty_step10,
  guesty_step11,
};

export { guestyStepByStepInstructions };
